module.exports = __webpack_public_path__ + "static/media/kr.4912cf8e.svg";